/* Adaptis: помилка під полем замість підказки браузера. 24.09.2026, ніч.
   Працює лише для полів .af-input, поруч з якими є рядок .af-err (його
   малює розмітка форми, текст узгоджений). Відправку не чіпає: подія
   invalid приходить, коли браузер уже зупинив відправку через порожнє чи
   хибне поле; тут ми тільки ховаємо спливну підказку й фарбуємо поле. */
(function () {
  if (window.AdaptisFormsInit) return;
  window.AdaptisFormsInit = true;

  function errOf(el) {
    var f = el.closest && el.closest('.af-field');
    return f ? f.querySelector('.af-err') : null;
  }

  /* 25.09.2026: два тексти для телефону: порожнє поле (data-miss) і
     неправильний номер, наприклад букви (data-bad). */
  function say(el) {
    var er = errOf(el);
    if (!er) return;
    var t = el.validity && el.validity.valueMissing ? er.getAttribute('data-miss') : er.getAttribute('data-bad');
    if (t) er.textContent = t;
  }
  function mark(el) { say(el); el.classList.add('is-bad'); }

  document.addEventListener('invalid', function (e) {
    var el = e.target;
    if (!el.classList || !el.classList.contains('af-input') || !errOf(el)) return;
    e.preventDefault();
    mark(el);
    var form = el.form;
    if (form && form.querySelector(':invalid') === el) el.focus();
  }, true);

  /* 24.09.2026, ніч: поки людина вводить, помилки немає. Вона з'являється,
     коли людина вийшла з поля з хибним значенням або натиснула «Надіслати». */
  function isAf(el) { return el && el.classList && el.classList.contains('af-input'); }
  document.addEventListener('input', function (e) {
    if (isAf(e.target)) e.target.classList.remove('is-bad', 'has-error');
  }, true);
  document.addEventListener('focusout', function (e) {
    var el = e.target;
    if (!isAf(el) || !errOf(el)) return;
    if (el.value.trim() !== '' && !el.checkValidity()) mark(el);
    else if (el.checkValidity()) el.classList.remove('is-bad');
  }, true);

  /* 25.09.2026: форма з novalidate (супровід) сама перевіряє лише порожні
     поля. Неправильний номер зупиняємо тут, до її обробника: відправка при
     цьому не міняється, вона просто не починається з хибними даними. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.noValidate || !f.classList || !f.classList.contains('af-form')) return;
    var bad = [].slice.call(f.querySelectorAll('.af-input')).filter(function (el) { return errOf(el) && el.value.trim() !== '' && !el.checkValidity(); });
    if (!bad.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    bad.forEach(mark);
    bad[0].focus();
  }, true);
})();
